export default __webpack_public_path__ + "static/media/IMG_1248.4808f003.JPG";